module.exports = __webpack_public_path__ + "static/media/Waveform.a0818ed4.svg";